import React, { ReactElement, useRef } from 'react';

import { Theme, Button, Accordion, AccordionDetails, AccordionSummary, Typography, AccordionActions, TextField } from '@material-ui/core';
import { createStyles, makeStyles, ThemeOptions } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AlmeTheme, AlmeThemeMode } from '../../../models/AlmeTheme';

const useStyles = makeStyles(({ spacing }: Theme) =>
    createStyles({
        root: {
            width: '60%',
        },
        themeTextarea: {
            width: '100%',
        },
    }),
);

interface AlmeThemeToolProps {
    setTheme: (theme: AlmeTheme) => void;
    theme: AlmeTheme;
    themeMode: AlmeThemeMode;
}

export default function AlmeThemeTool(props: AlmeThemeToolProps): ReactElement {
    const classes = useStyles();
    const appTheme = props.themeMode === 'dark' ? props.theme.darkTheme : props.theme.lightTheme;

    const textareaValue = JSON.stringify(appTheme, null, 4);
    const useThemeTextareaRef = useRef<HTMLTextAreaElement>(null);

    const applyThemeClick = () => {
        const themeOptions = useThemeTextareaRef.current?.value;
        if (!themeOptions) {
            return;
        }
        const customTheme = JSON.parse(themeOptions) as ThemeOptions;

        const customMuiTheme = {
            lightTheme: customTheme.palette?.type === 'light' ? customTheme : props.theme.lightTheme,
            darkTheme: customTheme.palette?.type === 'dark' ? customTheme : props.theme.darkTheme,
        } as AlmeTheme;

        props.setTheme(customMuiTheme);
    };

    return (
        <div className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-custom-theme-content"
                    id="panel-custom-theme-header"
                >
                    <Typography variant='h6'>Custom Theme</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <TextField
                        multiline
                        defaultValue={textareaValue}
                        className={classes.themeTextarea}
                        inputRef={useThemeTextareaRef}
                        variant="outlined"
                        label="Edit Custom Theme"
                    ></TextField>
                </AccordionDetails>
                <AccordionActions>
                    <Button color='primary' variant='contained' onClick={applyThemeClick}>Apply Theme</Button>
                </AccordionActions>
            </Accordion>
        </div>
    );
}